export const workspaceShortcuts: Record<
  string,
  { label: string; description: string; href: string; configure?: boolean }[]
> = {
  'order-editing': [
    {
      label: 'Review order edit requests',
      description: 'Review customer changes in the shared Requests workspace.',
      href: '/requests?type=ORDER_EDITING',
      configure: true,
    },
    {
      label: 'View Order Editing activity',
      description: 'Review editing usage and operations in Reports.',
      href: '/requests/reports?report=order-editing',
      configure: true,
    },
    {
      label: 'Review editing setup',
      description: 'Check installation and the customer experience.',
      href: '/order-settings/all',
      configure: true,
    },
  ],
  'returns-exchanges': [
    {
      label: 'Review return requests',
      description: 'Open your customer return and exchange workflow.',
      href: '/returns',
    },
    {
      label: 'Review return policy',
      description: 'Keep eligibility and resolutions up to date.',
      href: '/settings/resolution-portal/returns/policy',
      configure: true,
    },
    {
      label: 'Customize the Resolve Center',
      description: 'Review your customer portal settings.',
      href: '/settings/resolution-portal/general',
      configure: true,
    },
  ],
  'delivery-guarantee': [
    {
      label: 'Review delivery issues',
      description: 'Move customer delivery requests toward resolution.',
      href: '/claims',
    },
    {
      label: 'View request reports',
      description: 'Review your customer resolution performance.',
      href: '/requests/reports',
      configure: true,
    },
    {
      label: 'Review guarantee settings',
      description: 'Fine-tune your fee and customer experience.',
      href: '/settings/protection',
      configure: true,
    },
  ],
  impact: [
    {
      label: 'Review your impact add-ons',
      description: 'Manage Tree Planting and Free Gifts for your store.',
      href: '/settings/impact',
      configure: true,
    },
  ],
  'shipping-rates': [
    {
      label: 'Go to shipping workspace',
      description: 'Manage your labels and shipments in the shipping portal.',
      href: 'https://ship.shipaid.com',
    },
    {
      label: 'Review your rate application',
      description: 'Access your application and approval information.',
      href: 'https://apply.shipaid.com',
      configure: true,
    },
  ],
  fulfillment: [
    {
      label: 'Go to fulfillment workspace',
      description: 'Access your inventory, orders, and warehouse operations.',
      href: 'https://fulfill.shipaid.com',
    },
  ],
};
